import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type AuthTokenState = {
  token: string
  expiration: number
}

type AuthState = {
  auth: AuthTokenState | null
  setAuthToken: (authState: AuthTokenState) => void
  removeAuthToken: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      auth: null,
      setAuthToken: (authState) => {
        return set({ auth: authState })
      },
      removeAuthToken: () => {
        set({ auth: null })
      },
    }),
    {
      name: 'auth',
    }
  )
)
